import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPpt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#ppt_svg__a)">
      <path d="M2 13.783h15.709v1.122H2zm0 2.805h15.709v1.122H2z" />
      <g clipPath="url(#ppt_svg__b)">
        <path d="M13.326 7.865H9.782V4.134a.18.18 0 0 0-.178-.178 3.914 3.914 0 0 0-3.909 3.909 3.913 3.913 0 0 0 3.909 3.908 3.9 3.9 0 0 0 3.9-3.722.18.18 0 0 0-.05-.131.18.18 0 0 0-.128-.055" />
        <path d="M11.232 2.33a.18.18 0 0 0-.178.177v3.909c0 .098.08.178.178.178h3.722a.18.18 0 0 0 .178-.169l.004-.06q.003-.062.005-.127a3.914 3.914 0 0 0-3.909-3.908" />
      </g>
    </g>
    <defs>
      <clipPath id="ppt_svg__a">
        <path d="M2 2h15.668v15.668H2z" />
      </clipPath>
      <clipPath id="ppt_svg__b">
        <path d="M4.805 1.44h10.659v10.659H4.805z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPpt;
